export interface IViewAcceleration {
    viewId: string;
    accelerationState: string;
    allowedByAdmin?: boolean;
}

/**
 * This enum corresponds to IMaterializedViewService.AccelerationState. It is supposed to be used for
 * CommonColumn.Acceleration
 */
export enum ViewDataAccelerationState {
    Failed = 'Failed',
    Pending = 'Pending',
    Off = 'Off',
    On = 'On',
}